class Display {
  static polar(r: number, a: number): {x: number; y: number} {
    a = -(a - Math.PI / 2);
    return {
      x: r * Math.cos(a),
      y: -r * Math.sin(a),
    };
  }

  static angleToDisplayDegrees(a: number): number {
    return (a / Math.PI) * 180;
  }
}

export default Display;
